// 언어별 섹션 제목
export const sectionTitles = {
  kr: {
    basicInfo: '기본 정보',
    introduction: '소개',
    summary: '요약',
    coreCompetencies: '핵심 역량',
    keyStrengths: '핵심 역량',
    experience: '경력 사항',
    education: '학력',
    papers: '논문 및 연구',
    certificates: '자격증 및 수상 내역',
    skills: '보유 기술',
    contact: '연락처',
    phone: '연락처',
    email: '이메일',
    address: '주소',
    profile: '프로필',
    footer: 'Generated by Latte AI Resume Consultant'
  },
  en: {
    basicInfo: 'BASIC INFORMATION',
    introduction: 'INTRODUCTION',
    summary: 'SUMMARY',
    coreCompetencies: 'Core Competencies:',
    keyStrengths: 'KEY STRENGTHS',
    experience: 'PROFESSIONAL EXPERIENCE',
    education: 'EDUCATION',
    papers: 'PUBLICATIONS & RESEARCH',
    certificates: 'CERTIFICATIONS & AWARDS',
    skills: 'SKILLS',
    contact: 'CONTACT',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    profile: 'PROFILE',
    footer: 'Generated by Latte AI Resume Consultant'
  }
};

// 기본 placeholder 데이터
export const defaultPlaceholderData = {
  name: '라떼는',
  title: 'AI 기반 혁신을 주도하는 경력 15년차 AI PM / Product Owner',
  phone: '010-0000-0000',
  email: 'latteis.kim@latteis.com',
  github: '',
  address: '',
  summary: '15년 이상의 IT 경력을 보유한 AI 전문 프로덕트 매니저(PM) 및 Product Owner입니다. 다수의 AI 서비스와 MLOps 플랫폼의 성공적인 기획, 개발, 출시 및 운영을 이끌었습니다. 데이터 기반 의사결정과 사용자 중심의 제품 개발 철학을 바탕으로 비즈니스 가치를 창출하고 팀의 성장을 도모합니다. 새로운 기술 트렌드에 대한 깊은 이해와 뛰어난 커뮤니케이션 능력을 갖추고 있습니다.',
  keyStrengths: [
    '기술 기반의 비즈니스 문제 해결: 백엔드 개발 역량을 바탕으로 복잡한 기술적 문제를 해결하고, AI/ML 기술을 비즈니스에 효과적으로 접목하여 실제적인 성과를 창출',
    '데이터 기반의 전략적 의사결정: 데이터 분석 리드로서 방대한 데이터를 심층적으로 분석하고, 이를 기반으로 제품 전략 및 비즈니스 의사결정에 기여',
    '혁신적인 AI 프로덕트 리더십: 개발 및 데이터 분석 전문성을 아우르며 AI 제품의 기획부터 출시, 성장에 이르는 전 과정을 성공적으로 리드하고 다기능 팀을 효과적으로 이끌어내는 리더십 발휘'
  ],
  experiences: [
    {
      position: 'AI PM',
      company: 'Latte AI',
      startDate: '2021.01',
      endDate: '현재',
      overallDescription: "Latte AI 전사 과제 및 중장기 로드맵 수립, 서비스 기획 및 릴리즈 PM 총괄\n전사 AI 기술 방향성 제시 및 신규 AI 서비스 인큐베이션 담당",
      projects: [
        {
          projectName: "MLOps 플랫폼 구축 및 운영 리드",
          projectDescription: "AI 모델 학습, 관리, 배포 통합 지원 플랫폼 기획 및 구축 총괄\n분산된 ML 인프라 및 자원 통합으로 공통 자원 활용 효율성 증대 및 관리 오버헤드 60% 감소\n전사 모델 및 데이터 세트 공유 체계 마련으로 협업 및 생산성 50% 향상 기여\n전사 인프라 비용 약 70% 감축, 중복 리소스 약 50% 절감, 전사 ML 사용자 80% 이상 확보 및 MAU 90% 달성"
        },
        {
          projectName: "생성형 AI 기반 Latte AI 어시스턴트 프로젝트",
          projectDescription: "프로젝트 기획 및 사용자 경험(UX) 설계 주도\n생성형 AI 사용자 데이터 및 퍼널 분석을 통한 심층 인사이트 도출\n목표 KPI 대비 Revenue 20% 초과 달성"
        }
      ]
    }
  ],
  education: [
    {
      degree: '컴퓨터공학 석사',
      school: '한국대학교 AI 대학원',
      startDate: '2009.03',
      endDate: '2011.02',
      major: '인공지능 전공'
    }
  ],
  skills: ['AI 서비스 기획', '프로덕트 매니지먼트(PM)', 'MLOps', 'Agile', '데이터 분석', 'Python', 'SQL'],
  certificates: [
    {
      name: 'Certified AI Product Manager (CAIPM)',
      issuer: 'Product Management HQ',
      date: '2022.05'
    }
  ]
};



// 논문 타입 텍스트 매핑
export const paperTypeMap = {
  'journal': '학술지 논문',
  'conference': '학회 발표',
  'preprint': '프리프린트',
  'book': '도서/챕터',
  'patent': '특허'
};
